<main>
    @if ($showLoader()) {
        <ea-loader />
    }
    <router-outlet />
</main>
<div class="ea-snackbar-stack">
    @for (snackbar of snackbarService.$snackbars(); track snackbar.id) {
        <ea-snackbar [$id]="snackbar.id"
            [$message]="snackbar.message"
            [$statusType]="snackbar.statusType" />
    }
</div>
